import React from 'react'
import IconsAuraExp22 from './Images/IconsAuraExp22.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCircleChevronRight} from '@fortawesome/free-solid-svg-icons';



function ExpCard22() {
  return (

    <div className='ExpPgCard  '>
      
        <p className='ExpPgHExpName'> Nature & Wildlife </p>

        <p className='ExpPgHCat'> Nature </p>
        <p className='ExpPgHCode'> AURAMUSE122 </p>


      
        <div className='IconsAuraExpDiv'>  <img className='IconsAuraExp' src={IconsAuraExp22} /> </div>

        <FontAwesomeIcon className='FaIconCirc' icon={faCircleChevronRight} size="xl" style={{color: " ", }} />
        
    </div>




    
  )
}

export default ExpCard22